module.exports = __webpack_public_path__ + "static/media/tramites_img.548880e8.svg";